import { omniaResolve } from "../promises"
import { IOmniaHttpService } from "../types"
import { AppServiceImpl } from "./appService"
import { IAppMachine } from "./types"

/** @internal */
export class AppMachinesService {

    constructor(private appSvc: AppServiceImpl, private ohttp: IOmniaHttpService) {
    }

    resolve<T>(value: T) {
        return omniaResolve(value)
    }

    getMachines(connectionId: string, orgId: string): ng.IPromise<IAppMachine[]> {
        const url = `/api/apps/machines/${connectionId}?orgId=${orgId}`
        return this.ohttp.get(url, false).then(r => r.data)
    }

}
